import { useFeatures, type WorkspaceFeatures } from "@expert/features";
import { gaiaWsEventBus } from "@expert/gaia";
import type { LocationCues, MessageSuggestion } from "@expert/shared-types";
import { useEffect } from "react";
import { getRootDispatcher } from "@/analytics";
import { useRapportBuildingStore } from "./useRapportBuildingStore";

export type RapportBuildingMessage = Record<string, string[]>;

export function useRapportBuildingListener() {
    const {
        features: { isRapportEnabled },
    } = useFeatures<WorkspaceFeatures>();

    useEffect(() => {
        if (isRapportEnabled) {
            return gaiaWsEventBus.on("gaia_ws_message-suggestion", ({ body, correlationId }) => {
                const msg = body as MessageSuggestion;
                const appId = msg.suggestion.metadata?.applicationIdentifier;
                if (appId !== "rapport-building" && appId !== "location-cues") {
                    return;
                }
                if (appId === "rapport-building") {
                    const message = msg.suggestion.message as unknown as RapportBuildingMessage;
                    const questions = Object.values(message);

                    useRapportBuildingStore.getState().updateQuestions(questions);

                    void getRootDispatcher().dispatchBusinessEvent("RapportQuestionsReceived", {
                        correlationId,
                        questions,
                        partner: msg.partner,
                        sessionGroupId: msg.sessionGroupId,
                        sessionId: msg.sessionId,
                    });
                } else {
                    const cues = (msg.suggestion.cues as LocationCues[]) || [];

                    const state = cues.find((cue) => cue.type === "LOCATION_STATE")?.name || "";
                    const city = cues.find((cue) => cue.type === "LOCATION_CITY")?.name || "";

                    if (state) {
                        const locationData = {
                            state,
                            ...(city ? { city } : {}),
                        };

                        useRapportBuildingStore.getState().updateLocation(locationData);
                    }
                    void getRootDispatcher().dispatchBusinessEvent("LocationCuesReceived", {
                        correlationId,
                        state,
                        city,
                        partner: msg.partner,
                        sessionGroupId: msg.sessionGroupId,
                        sessionId: msg.sessionId,
                    });
                }
            });
        }
    }, [isRapportEnabled]);
}
